import { BellIcon } from '@heroiconsv2/react/24/outline'
import { SectionCard } from './BookingSection'

const BookingCompanyAlertsCard = ({ bookingData, t, isCompanyRole, hasAdminAccess, onViewBooking }) => {
  if (isCompanyRole && !hasAdminAccess) return null
  if (!bookingData?.companyAlerts?.length) return null

  return (
    <SectionCard icon={BellIcon} title={t('booking.sections.bookingAlerts')}>
      <div className="max-h-[420px] space-y-2.5 overflow-y-auto pr-1">
        {bookingData.companyAlerts.map((alert, index) => (
          <div key={index} className="flex items-start gap-3 rounded-xl border border-slate-200/80 bg-slate-50/30 p-3.5">
            <span className="mt-1.5 h-2 w-2 flex-shrink-0 rounded-full bg-blue-600" />
            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold text-slate-900">{alert.title.en}</div>
              <div className="mt-1 text-xs leading-relaxed text-slate-500">{alert.description.en}</div>
            </div>
            <button
              type="button"
              onClick={() => onViewBooking(alert.id)}
              className="flex-shrink-0 self-center rounded-lg bg-blue-50 px-3 py-1.5 text-xs font-semibold text-blue-700 transition hover:bg-blue-100"
            >
              {t('booking.buttons.viewBooking')}
            </button>
          </div>
        ))}
      </div>
    </SectionCard>
  )
}

export default BookingCompanyAlertsCard
